var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPaymentMethodBinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.20264,
    y: 3.84766,
    width: 21,
    height: 14.3043,
    rx: 2,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.79958 10.2181L11.7028 8.31505L13.6069 10.2191L14.7143 9.11175L11.7028 6.1001L8.69218 9.11074L9.79958 10.2181ZM9.01754 10.9999L7.91017 9.89255L6.80273 11L7.91011 12.1074L9.01754 10.9999ZM11.7028 13.6851L9.79958 11.7821L8.69056 12.888L8.69211 12.8895L11.7028 15.9001L14.7143 12.8885L14.7149 12.8879L13.6069 11.7811L11.7028 13.6851ZM15.4954 12.1079L16.6029 11.0005L15.4955 9.89307L14.3881 11.0005L15.4954 12.1079ZM12.8265 10.9995H12.826L12.827 11.0001L12.8265 11.0007L11.7027 12.1244L10.58 11.0017L10.5785 11.0001L10.58 10.9985L10.7769 10.8017L10.8722 10.7062H10.8723L11.7027 9.87579L12.8265 10.9995Z",
    fill: "#F3BA2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaymentMethodBinance);
export default __webpack_public_path__ + "static/media/icon_payment_method_binance.770f2f7d7695fbfca1d004fee27e5321.svg";
export { ForwardRef as ReactComponent };